import { Environment } from '../../env/Environment';
import { Typography } from '../primitives';
import { Trans } from '@rpi/i18n';

export const VolumeDiscountTableFooter = () => {
  return (
    <div className="text-center flex flex-col gap-4">
      <Typography variant="title-small">
        <Trans i18nKey="route.cart.need_more_than_100" />
      </Typography>
      <Typography variant="body">
        <Trans
          i18nKey="route.cart.contact_los"
          components={{
            'los-link': (
              <a
                aria-label="LOS Link"
                href={Environment.LINK.BLURB_LOS}
                target="_blank"
                rel="noopener noreferrer"
              />
            ),
          }}
        />
      </Typography>
    </div>
  );
};
